(function() {

var _ = ui._;
var timer;
var isTouch = 'ontouchstart' in w;
var bannersID = 'home-banners-list';
var scrollX;
var startX;
var $banners;
ui.afterBannerScroll = afterBannerScroll;
ui.bannerScroll = bannerScroll;
ui.loadAdd(onLoad);
ui.afterSessionInitAdd(viewedShow);

function onLoad(event) {
  $banners = _('#' + bannersID);
  if($banners.el) {
    if(isTouch)
      $banners
        .on('touchstart', onTouchStart)
        .on('touchmove', onTouchMove)
        .on('touchend', onTouchEnd);
    else
      $banners.parent().append(
        _('span').attr('onclick', 'ui.bannerScroll(true)', 'class', 'scroll-v-btn home-banners-list-btn home-banners-list-btn-left').append(_('i').attr('class', 'fa fa-chevron-left')),
        _('span').attr('onclick', 'ui.bannerScroll(false)', 'class', 'scroll-v-btn home-banners-list-btn home-banners-list-btn-right').append(_('i').attr('class', 'fa fa-chevron-right'))
      );
    timer = setTimeout(bannerScroll, 50000);
  }
}

function afterBannerScroll(list, indexCur, index) {
  var indicator_class = 'image-indicator-active';
  _('#banner-' + indexCur).toggleClass(indicator_class, false);
  _('#banner-' + index).toggleClass(indicator_class, true);
}

function bannerScroll(isLeft) {
  if(timer)
    clearTimeout(timer);
  ui.scroll(bannersID, isLeft);
  timer = setTimeout(bannerScroll, 10000, false);
}

function viewedShow() {
  if(ui.session_data.viewed && ui.session_data.viewed.length) {
    var $he = _('#product-list-viewed'), product;
    for(var i = 0; i < ui.session_data.viewed.length; i++) {
      product = ui.productGet(ui.session_data.viewed[i]);
      if(product)
        $he.append(ui.productBuild(product));
    }
    _('#product-list-viewed-box').toggleClass('hidden', false);
  }
}

function onTouchEnd(event) {
  var isLeft = event.changedTouches[0].clientX > startX;
  scrollX = 0;
  startX = 0;
  bannerScroll(isLeft);
}

function onTouchMove(event) {
  $banners.el.scrollLeft = scrollX - event.changedTouches[0].clientX + startX;
}

function onTouchStart(event) {
  if(timer)
    clearTimeout(timer);
  scrollX = $banners.el.scrollLeft;
  startX = event.changedTouches[0].clientX;
}

})();